import { Success as SuccessComponent } from '../components/success'

export const Success = () => {
  return (
    <div>
      <SuccessComponent />
    </div>
  )
}
